export const estimateEmailSent = {
  'estimate_email_sent.head_title': 'Odhad ceny',
  'estimate_email_sent.title': 'Úspěšně odesláno',
  'estimate_email_sent.subtitle':
    'Na adresu <b>{email}</b> jsme právě zaslali e-mail s vaším odhadem ceny.',
  'estimate_email_sent.box':
    'Pokud e-mail s odhadem nenajdete ve složce Doručené pošty, <b>zkontrolujte složku Hromadné nebo Spam.</b>',

  'estimate_email_sent.edit_email': 'Uvedli jste špatný e-mail?',
  'estimate_email_sent.edit_email_cta': 'Upravit e-mail',

  'estimate_email_sent.ready_to_sell.title': 'Připraveni prodat?',
  'estimate_email_sent.ready_to_sell.subtitle':
    'Svěřte svůj prodej expertům a zajistěte si maximální cenu a bezpečný průběh.',
  'estimate_email_sent.ready_to_sell.cta': 'Zjistit možnosti prodeje',

  'estimate_email_sent.ready_to_sell.name': 'Anna',
  'estimate_email_sent.ready_to_sell.description':
    'Realitní specialistka Reas.cz',
};
